import { normalizeGenderForFilter } from '../../utils/genderUtils.js';

export const filterOutfitsByGender = (outfits, gender) => {
  if (!gender || gender === 'all') return outfits || [];
  return (outfits || []).filter((outfit) => {
    const outfitGender = normalizeGenderForFilter(outfit?.gender);
    if (!outfitGender || outfitGender === 'all') return true;
    return outfitGender === gender;
  });
};

export const sortOutfitsByIdAsc = (outfits) =>
  [...(outfits || [])].sort((a, b) => Number(a.id) - Number(b.id));
